import { type AxiosInstance } from 'axios'

export default (axios: AxiosInstance, { baseApi }: { baseApi: string }) => ({
  listAll() {
    return axios.get('/v1/tenants/get/')
  },
  fetchData(prefix: string = '') {
    return this.listAll().then(({ data: tenants }) => {
      return tenants.find(
        ({ subdomain_prefix }: { subdomain_prefix: string }) =>
          subdomain_prefix === prefix,
      )
    })
  },
  validate(domainSlug: string) {
    return fetch(`${baseApi}v1/tenants/subdomains/${domainSlug}/`)
  },
})
